import { render, staticRenderFns } from "./Gettingstarted.vue?vue&type=template&id=639aa01a&"
import script from "./Gettingstarted.vue?vue&type=script&lang=js&"
export * from "./Gettingstarted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports